export const mapImage = (image): Content.Image => {
	if (!image) {
		return null;
	}

	return {
		url: image.url,
		focalPoint: mapImageFocalPoint(image.focalPoint),
		width: image.width,
		height: image.height,
		bytes: image.bytes,
		extension: image.extension,
	};
};

export const mapFirstImage = (images: Umbraco.Image[]): Content.Image => {
	if (!images || images.length === 0) {
		return null;
	}
	return mapImage(images[0]);
};

export const mapImages = (images: Umbraco.Image[]): Content.Image[] => {
	if (!images) {
		return null;
	}
	return images.map(mapImage);
};

const mapImageFocalPoint = (focalPoint): { top: number; left: number } => {
	if (!focalPoint) {
		return null;
	}

	return {
		top: focalPoint.top,
		left: focalPoint.left,
	};
};
